import { GA } from 'types';
import getSelectItemEvent, { SelectItemEvent, SelectItemData } from './utils/getSelectItemEvent';
import getMenuClickEvent, { MenuClickEvent, MenuClickData } from './utils/getMenuClickEvent';
import getCTAClickEvent, { CTAClickData, CTAClickEvent } from './utils/getCTAClickEvent';

export type Data = SelectItemData | MenuClickData | CTAClickData;

type Event = SelectItemEvent | MenuClickEvent | CTAClickEvent;

const getGAEvent = (data: Data): Event => {
  switch (data.type) {
    case GA.EventType.MENU_CLICK:
      return getMenuClickEvent(data);
    case GA.EventType.CTA_CLICK:
      return getCTAClickEvent(data);
    default:
      return getSelectItemEvent(data);
  }
};

export default getGAEvent;
